/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { LoggerStore } from "../../logger/logger-store"
import type { Result } from "../../network/http-client"
import { makeGetRequest } from "../../network/http-client"
import type { ApplicationDetail } from "../application-detail/application-detail-types"

enum Endpoint {
    searchAvUserId = "/api/private/application/av-user-id/:search", // single result
    searchClientDeviceId = "/api/private/application/client-device-id/:search", // array result
    searchClientUserId = "/api/private/application/client-user-id/:search" // array result
}

export class ApplicationSearchService {
    private readonly searchPlaceholder = ":search"

    constructor(private readonly logger: LoggerStore) {}

    async searchByAvUserId(avUserId: string): Promise<Result<ApplicationDetail>> {
        const detail = await makeGetRequest<ApplicationDetail>(
            Endpoint.searchAvUserId.replace(this.searchPlaceholder, avUserId),
            {}
        )
        if (!detail.success) {
            this.logger.logApiError("Search by avUserId failed", detail.apiError, detail.error)
        }
        return detail
    }

    async searchByClientDeviceId(clientDeviceId: string): Promise<Result<ApplicationDetail[]>> {
        const detail = await makeGetRequest<ApplicationDetail[]>(
            Endpoint.searchClientDeviceId.replace(this.searchPlaceholder, clientDeviceId),
            {}
        )
        if (!detail.success) {
            this.logger.logApiError("Search by client device failed", detail.apiError, detail.error)
        }
        return detail
    }

    async searchByClientUserId(clientUserId: string): Promise<Result<ApplicationDetail[]>> {
        const detail = await makeGetRequest<ApplicationDetail[]>(
            Endpoint.searchClientUserId.replace(this.searchPlaceholder, clientUserId),
            {}
        )
        if (!detail.success) {
            this.logger.logApiError("Search by client user id failed", detail.apiError, detail.error)
        }
        return detail
    }
}
